import { isBetween } from "shared/utils/date";
import type { ExplorerPage } from "shared/types/ExplorerPage";

export function getShowExplorerPageEnrollButton(explorerPage: ExplorerPage): boolean {
  return !!(
    explorerPage.benAdminPlatformUrl != null &&
    explorerPage.openEnrollmentStart &&
    explorerPage.openEnrollmentEnd &&
    isBetween(explorerPage.openEnrollmentStart, explorerPage.openEnrollmentEnd)
  );
}
